import React from "react";
import styles from "./UserGuide.module.css";
import { translate } from "../../../../common/providers";
import { I18nTranslate } from "../../../../common/components";

const UserGuide = () => (
	<div className={styles.container}>
		<div className={styles.title}>
			<strong>{translate("ai-chat.user-guide.welcome")}</strong>
		</div>
		<div className={styles.propositions_points}>
			<I18nTranslate translationKey="ai-chat.user-guide.text.part-1" />
		</div>
		<div className={styles.propositions_points}> {translate("ai-chat.user-guide.text.part-2")}</div>
		<div className={styles.propositions_points}>
			<I18nTranslate translationKey="ai-chat.user-guide.text.part-3" />
		</div>
		<div className={styles.propositions_points}>
			<I18nTranslate translationKey="ai-chat.user-guide.contact" />
		</div>
	</div>
);

export default UserGuide;
